<section [formGroup]="current_status" fxLayout="column" fxLayoutGap="8px">

  <!--
  <ng-container *ngIf="employment_status.value===looking">
    <mat-form-field>
      <mat-select placeholder="Destination Country" required [formControl]="destined_country">
        <ng-container *ngFor="let country of country.list|async">
          <mat-option [value]="country.alpha2" *ngIf="country.name !== 'Philippines'">
            {{country.name}}
          </mat-option>
        </ng-container>
      </mat-select>
      <mat-error *ngIf="destined_country.hasError('required')">Required.</mat-error>
    </mat-form-field>

    <mat-form-field>
      <input matInput placeholder="Job Title" required [formControl]="job_title">
      <mat-error *ngIf="job_title.hasError('required')">Required.</mat-error>
    </mat-form-field>
  </ng-container>
  -->

  <div fxLayout="row" fxLayoutGap="40px" fxLayout.xs="column" fxLayoutGap.xs="8px">
    <div fxLayout="column" fxLayoutGap="8px" fxFlex="50">
      <mat-form-field>
        <input matInput placeholder="Average monthly remittance (last 3 months)" required formControlName="average_monthly_remittance"
              type="number">
        <mat-error *ngIf="current_status.get('average_monthly_remittance').hasError('required')">Required.</mat-error>
      </mat-form-field>
    </div>

    <div fxLayout="column" fxLayoutGap="0px" fxFlex="50">
      <!-- empty div to balance columns -->
    </div>
  </div>

</section>
